import { render, staticRenderFns } from "./ForumReplyManage.vue?vue&type=template&id=0644dbb8&scoped=true&"
import script from "./ForumReplyManage.vue?vue&type=script&lang=js&"
export * from "./ForumReplyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644dbb8",
  null
  
)

export default component.exports